import { render, staticRenderFns } from "./inflections-subtables-wide.vue?vue&type=template&id=1cd710e4&"
import script from "./inflections-subtables-wide.vue?vue&type=script&lang=js&"
export * from "./inflections-subtables-wide.vue?vue&type=script&lang=js&"
import style0 from "./inflections-subtables-wide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1cd710e4', component.options)
    } else {
      api.reload('1cd710e4', component.options)
    }
    module.hot.accept("./inflections-subtables-wide.vue?vue&type=template&id=1cd710e4&", function () {
      api.rerender('1cd710e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections-subtables-wide.vue"
export default component.exports